import { Autocomplete, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from "@mui/material";
import { trackActivity } from "../../../../utils/mixpanel";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { globalPutService } from "../../../../utils/globalApiServices";
import { checkApiStatus } from "../../../../utils";
import { enqueueSnackbar } from "notistack";
import { updateEngineRightApi } from "../apiServices";
const EngineRightRU = ({ modeType, editEngineRightInfo, onOpenAttachments, onToggleModal, getResponseBack }) => {
    const params = useParams();
    const [data, setData] = useState(editEngineRightInfo?.data);
    const [isLoading, setLoading] = useState(false);

    const onEditEngineRight = () => {
        setLoading(true);
        globalPutService(updateEngineRightApi(params?.leaseSlug), data)
            .then(async (response) => {
                if (checkApiStatus(response)) {
                    getResponseBack()
                    onToggleModal();
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Edited', { page_title: `Edit Engine Right`, success_msg: response?.data?.message, item_slug: params, payload: data, response: response?.data })
                } else {
                    enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } })
                    trackActivity('Item Edited', { page_title: `Edit Engine Right`, error_msg: response?.data?.message, item_slug: params, payload: data, response: response?.data })
                }
                setLoading(false);
            })
    }

    const onFieldChange = (key, value) => {
        setData({ ...data, lessor_extra_fields: { ...data.lessor_extra_fields, [key]: value } })
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'edit' ? 'Edit' : 'View'} Engine Right`, page_type: page_type, })
    }
    return (
        <Dialog
            aria-labelledby="customized-dialog-title"
            className='add-lease-dialog'
            maxWidth='md'
            fullWidth
            open={editEngineRightInfo?.modal}
        >
            <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                <Typography className="dialog-header-title">{modeType === 'edit' ? 'Edit Engine Right' : 'View Engine Right'}</Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <Autocomplete
                            disablePortal
                            options={['YES', 'NO']}
                            value={data?.lessor_extra_fields?.engine_title_swap_rights || null}
                            onChange={(e, value) => onFieldChange('engine_title_swap_rights', value)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Engine Title Swap Rights"
                                    margin='normal'
                                    size='small'
                                    slotProps={{ inputLabel: { shrink: true, }, input: { ...params?.InputProps, } }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <Autocomplete
                            disablePortal
                            options={['YES', 'NO']}
                            value={data?.lessor_extra_fields?.engine_pooling_rights || null}
                            onChange={(e, value) => onFieldChange('engine_pooling_rights', value)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Engine Pooling Rights"
                                    margin='normal'
                                    size='small'
                                    slotProps={{ inputLabel: { shrink: true, }, input: { ...params?.InputProps, } }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <Autocomplete
                            disablePortal
                            options={['YES', 'NO']}
                            value={data?.lessor_extra_fields?.engine_swap_lessor_consent || null}
                            onChange={(e, value) => onFieldChange('engine_swap_lessor_consent', value)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Engine Swap Lessor Consent Required"
                                    margin='normal'
                                    size='small'
                                    slotProps={{ inputLabel: { shrink: true, }, input: { ...params?.InputProps, } }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <TextField
                            id="engine_right_remark"
                            value={data?.lessor_extra_fields?.engine_right_remark || ''}
                            onChange={(e) => onFieldChange('engine_right_remark', e.target.value)}
                            label="Remarks"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            fullWidth
                            multiline
                            rows={3}
                            sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                            slotProps={{ inputLabel: { shrink: true } }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions className="dialog-action">
                <Button className='cancel-btn' disabled={isLoading} variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}> Cancel </Button>
                <Button variant='contained' className='btn-primary' size='small' disabled={modeType === "view"} onClick={() => { handleItemClicked('Save Button'); onEditEngineRight(); }}>
                    {isLoading ? <CircularProgress color='inherit' size={25} /> : "Save"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
export default EngineRightRU;